export { default } from './useFakeLazyQuery';
